// src/hooks/useProfileRealtime.js
import { useState, useEffect } from "react";
import { getProfileById } from "../APIs/ProfileApi";
import axiosInstance from "../APIs/axiosInstance";

export const useProfileRealtime = (profileId) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [followLoading, setFollowLoading] = useState(false);

  useEffect(() => {
    if (!profileId) return;
    const fetchProfile = async () => {
      try {
        setLoading(true);
        const res = await getProfileById(profileId);
        setProfile(res.data);
      } catch (err) {
        console.error("Profile fetch error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [profileId]);

  const handleFollowToggle = async () => {
    if (!profile) return;
    setFollowLoading(true);
    const action = profile.is_following ? "unfollow" : "follow";
    try {
      await axiosInstance.post(`/accounts/profiles/${profileId}/${action}/`);
      setProfile((prev) => ({
        ...prev,
        is_following: !prev.is_following,
        followers_count: prev.is_following
          ? prev.followers_count - 1
          : prev.followers_count + 1,
      }));
    } catch (err) {
      console.error("Follow error:", err);
    } finally {
      setFollowLoading(false);
    }
  };

  return { profile, setProfile, loading, followLoading, handleFollowToggle };
};